<template>
  <el-dialog :close-on-click-modal="false" v-dialogDrag :title="title" :visible.sync="detailDialog" width="80%" append-to-body :before-close="handleClose">
    <el-form :model="form" inline label-width="100px">
      <el-form-item label="单号:">
        <div class="editstaffdiv">
          {{form.docNum}}
        </div>
      </el-form-item>
      <el-form-item label="会员名字:">
        <div class="editstaffdiv">
          {{form.memberName }}
        </div>
      </el-form-item>
      <el-form-item label="业务名称:">
        <div class="editstaffdiv">
          {{form.tradeName }}
        </div>
      </el-form-item>
      <el-form-item label="类别:">
        <div class="editstaffdiv">
          <div v-show="form.docType=='card_use'">疗程单</div>
          <div v-show="form.docType=='card_recharge'">充值单</div>
        </div>
      </el-form-item>
      <br>
      <el-form-item label="成交金额:">
        <div class="editstaffdiv">
          {{form.tradeMoney }}
        </div>
      </el-form-item>
      <el-form-item label="待付金额:">
        <div class="editstaffdiv">
          {{form.debtMoney }}
        </div>
      </el-form-item>
      <el-form-item label="还款金额:">
        <div class="editstaffdiv">
          {{form.repayMoney }}
        </div>
      </el-form-item>
      <el-form-item label="实付金额:">
        <div class="editstaffdiv">
          {{form.payMoney }}
        </div>
      </el-form-item><br>
      <el-form-item label="补单日期:" v-show="form.isAddition==1">
        <div class="editstaffdiv">
          {{form.additionDate }}
        </div>
      </el-form-item>
      <div class="border-radius-10 border padding-xs bg-white   margin-bottom-xs" style="width:905px;margin-left:100px">
        <el-table :data="form.repayAccountListRequests" :summary-method="getSummaries" show-summary>
          <el-table-column align="center" prop="accountNum" show-overflow-tooltip label="帐户编码" min-width="100"></el-table-column>
          <el-table-column align="center" prop="accountName" show-overflow-tooltip label="帐户名称" min-width="100"></el-table-column>
          <el-table-column align="center" prop="accountName" label="帐户类型" min-width="80">
            <template slot-scope="scope">
              {{scope.row.accountType==0?'充值':'疗程'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payNumber" label="支付次数" min-width="75">
            <template slot-scope="scope">
              {{scope.row.payNumber?scope.row.payNumber:'--'}}
            </template>
          </el-table-column>
          <el-table-column align="center" prop="payMoney" label="支付金额" min-width="75"></el-table-column>
          <el-table-column align="center" prop="storeNum" show-overflow-tooltip label="门店编码" min-width="100"></el-table-column>
          <el-table-column align="center" prop="storeName" show-overflow-tooltip label="门店名称" min-width="100"></el-table-column>
        </el-table>
      </div>
      <el-form-item style="display: inline-block;" label="业务员：">
        <div class="flex justify-start align-start flex-wrap">
          <staffsles ref="staffsles" @staffslesData="staffslesData"></staffsles>
          <admin ref="admin" @adminData="adminData"></admin>
          <manager ref="manager" @managerData="managerData"></manager>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" plain @click="cancel()">取 消</el-button>
      <el-button size="mini" v-if="form.isCancel==0&&title!='明细'" type="primary" @click="subStaffRatio()">修 改</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { repayEditStaff, selectOne } from "@/api/eashier.js";
import admin from "@/components/staffList/admin/index";
import manager from "@/components/staffList/manager/index";
import staffsles from "@/components/staffList/staff/index";
export default {
  components: {
    staffsles,
    manager,
    admin,
  },
  data() {
    return {
      detailDialog: false,
      activeNames: "员工",
      rowfromWidth: "80px",
      sessionStorageData: {}, //门店参数集合
      title: "", //弹窗标题
      form: {}, //主对象
    };
  },

  methods: {
    //关闭弹窗前的回调方法
    handleClose() {
      this.form = Object.assign({});
      this.detailDialog = false;
    },
    setStaff() {
      var that = this;
      this.$nextTick(() => {
        that.$refs.staffsles.show(that.form.entities);
        that.$refs.admin.show(that.form.adminList);
        that.$refs.manager.show(that.form.managerList);
      });
    },
    //员工占比返回方法
    staffslesData(v) {
      console.log(v);
      this.form.entities = [...v];
    },
    //高管占比返回方法
    managerData(v) {
      this.form.managerList = [...v];
    },
    //管理员占比返回方法
    adminData(v) {
      this.form.adminList = [...v];
    },
    cancel() {
      this.detailDialog = false;
      this.$emit("detailData");
    },
    //组件传值
    show(form, text) {
      if (text == "明细") {
        this.title = text;
      } else {
        this.title = "明细/修改";
      }
      this.detailDialog = true;
      this.sessionStorageData = JSON.parse(
        sessionStorage.getItem("sessionStorageData")
      );
      this.getData(form);
    },
    getData(row) {
      this.form = { ...row };
      this.form.entities.forEach((item) => {
        item.staffName = item.saleStaffName;
        item.id = item.saleStaffId;
        item.identityCard = item.saleIdentityCard;
        item.ratio = item.saleRatio;
        item.staffNames = item.brandNumber + "--" + item.staffName;
      });
      selectOne({ type: 7, orderId: row.id }).then((res) => {
        if (res.code == "000000") {
          let managerList = [];
          let adminList = [];
          res.rows.forEach((item) => {
            if (item.staffType == 0) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              managerList.push(item);
            }
            if (item.staffType == 1) {
              item.staffNames = item.brandNumber + "--" + item.staffName;
              adminList.push(item);
            }
          });
          if (managerList.length == 0) {
            managerList.push({ ratio: 100 });
          }
          if (adminList.length == 0) {
            adminList.push({ ratio: 100 });
          }

          if (this.form.entities.length == 0) {
            this.form.entities.push({ ratio: 100 });
          }
          this.form.managerLists = managerList;
          this.form.adminList = adminList;
          var that = this;
          this.$nextTick(() => {
            that.$refs.staffsles.show(that.form.entities);
            that.$refs.manager.show(that.form.managerLists);
            that.$refs.admin.show(that.form.adminList);
          });
        } else {
          this.$alert(res.message, "加载门店高管", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },

    //指定列求和
    //数组按对应字段合计返回方法
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property == "spendMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else if (column.property == "payMoney") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              sums[index] = "--";
            }
          }, 0);
          sums[index] += " ";
        } else {
          sums[index] = "--";
        }
      });
      return sums;
    },
    subStaffRatio() {
      this.form.entities.forEach((item) => {
        delete item.type;
      });
      let salesmens = [];
      this.form.managerLists.forEach((item) => {
        if (item.id) {
          item.staffType = 0;
          salesmens.push(item);
        }
      });
      this.form.adminList.forEach((item) => {
        if (item.id) {
          item.staffType = 1;
          salesmens.push(item);
        }
      });
      let ids = {
        id: this.form.id,
        repayDate: this.form.repayDate,
        staffRequests: this.form.entities,
        salesmens: salesmens,
        repayMoney: this.form.repayMoney,
      };
      repayEditStaff(ids).then((res) => {
        console.log(res);
        if (res.code == "000000") {
          this.$message.success({ message: res.message });
          this.detailDialog = false;
          this.$emit("detailData");
        } else {
          this.$alert(res.message, "提示", {
            confirmButtonText: "确定",
            confirmButtonClass: "confirmbtnFalses",
            type: "warning",
            center: true,
            callback: (action) => {},
          });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/eashier/repayment/components/detail.vue